import React, { useEffect } from "react";
import { setPage } from '../../../../core/Global';
import CallsList from "../../../../components/calls/CallsList";



function CallsHistory() {

  useEffect(() => {
    setPage("Calls History", "Voice", "Calls");
  }, [])

  return (
    <div className="p-5">
      <CallsList />
    </div>
  );
}

export default CallsHistory;
